import Vue from 'vue'
import Router from 'vue-router'
import Admin from '../components/admin/Admin'
        Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'Index',
            component: function (resolve) {
                require(['../components/content/Index.vue'], resolve).default
            }
        },
        {
            path: '/index',
            name: 'Home',
            component: function (resolve) {
                require(['../components/content/Index.vue'], resolve).default
            }
        },
        {
            path: '/prices',
            name: 'Prices',
            component: function (resolve) {
                require(['../pages/prices.vue'], resolve).default
            }
        },
        {
            path: '/newevent',
            name: 'Newevent',
            component: function (resolve) {
                require(['../pages/newevent.vue'], resolve).default
            }
        },
        {
            path: '/faq',
            name: 'Faq',
            component: function (resolve) {
                require(['../pages/faq.vue'], resolve).default
            }
        },
        {
            path: '/manual',
            name: 'Manual',
            component: function (resolve) {
                require(['../pages/manual.vue'], resolve).default
            }
        },
        {
            path: '/contacts',
            name: 'Contacts',
            component: function (resolve) {
                require(['../components/content/contacts.vue'], resolve).default
            }
        },
        {
            path: '/user/settings',
            name: 'Settings',
            component: function (resolve) {
                require(['../components/users/settings.vue'], resolve).default
            },
            meta: {auth: true}
        },
        {
            path: '/user/security',
            name: 'Security',
            component: function (resolve) {
                require(['../components/users/security.vue'], resolve).default
            },
            meta: {auth: true}
        },
        {
            path: '/forgot',
            name: 'Forgot',
            component: function (resolve) {
                require(['../components/pages/reset.vue'], resolve).default
            }
        },
        {
            path: '/user',
            name: 'Mypage',
            component: function (resolve) {
                require(['../components/users/User.vue'], resolve).default
            }
        },
        {
            path: '/user/:id',
            name: 'User',
            component: function (resolve) {
                require(['../components/users/User.vue'], resolve).default
            }
        },
        {
            path: '/news',
            name: 'News',
            component: function (resolve) {
                require(['../components/news/News.vue'], resolve).default
            },
            meta: {auth: true}
        },
        {
            path: '/notifications',
            name: 'Notifications',
            component: function (resolve) {
                require(['../components/notifications/Notifications.vue'], resolve).default
            },
            meta: {auth: true}
        },
        {
            path: '/tasks',
            name: 'Activities',
            component: function (resolve) {
                require(['../components/tasks/tasks.vue'], resolve).default
            }
        },
        {
            path: '/activities',
            name: 'Activities',
            component: function (resolve) {
                require(['../components/activities/activities.vue'], resolve).default
            }
        },
        {
            path: '/activities/:id',
            name: 'ActivitiesShow',
            component: function (resolve) {
                require(['../components/activities/show.vue'], resolve).default
            }
        },
        {
            path: '/activities/:id/manage',
            component: function (resolve) {
                require(['../components/activities/settings/main.vue'], resolve).default
            },
            meta: {auth: true},
            children: [
                {
                    path: '',
                    component: function (resolve) {
                        require(['../components/activities/settings/settings.vue'], resolve).default
                    },
                },
            ]
        },
        {
            path: '/activities/:id/:action',
            name: 'ActivitiesActions',
            component: function (resolve) {
                require(['../components/activities/show.vue'], resolve).default
            }
        },
        {
            path: '/bill/:id',
            name: 'BillInfo',
            component: function (resolve) {
                require(['../components/activities/bills/view.vue'], resolve).default
            }
        },
        {
            path: '/events',
            name: 'Events',
            component: function (resolve) {
                require(['../components/events/Events.vue'], resolve).default
            }
        },
        {
            path: '/events/:id',
            name: 'EventShow',
            component: function (resolve) {
                require(['../components/events/show.vue'], resolve).default
            }
        },
        {
            path: '/admin',
            component: function (resolve) {
                require(['../components/admin/main.vue'], resolve).default
            },
            meta: {auth: true},
            children: [
                {
                    path: '',
                    component: function (resolve) {
                        require(['../components/admin/users.vue'], resolve).default
                    },
                },
                {
                    path: 'mailing',
                    component: function (resolve) {
                        require(['../components/admin/mailing.vue'], resolve).default
                    },
                },
                {
                    path: 'activities/new',
                    component: function (resolve) {
                        require(['../components/activities/settings/new.vue'], resolve).default
                    }
                },
                {
                    path: 'activities/:id',
                    component: function (resolve) {
                        require(['../components/activities/settings/main.vue'], resolve).default
                    },
                    children: [
                        {
                            path: '',
                            component: function (resolve) {
                                require(['../components/activities/settings/settings.vue'], resolve).default
                            },

                        },
                        {
                            path: 'publications',
                            component: function (resolve) {
                                require(['../components/activities/settings/publications.vue'], resolve).default
                            },
                        },
                        {
                            path: 'statistics',
                            component: function (resolve) {
                                require(['../components/activities/settings/statistics.vue'], resolve).default
                            },
                        },
                        {
                            path: 'review',
                            component: function (resolve) {
                                require(['../components/activities/settings/criterions.vue'], resolve).default
                            },
                        },
                        {
                            path: 'rules',
                            component: function (resolve) {
                                require(['../components/activities/settings/rules.vue'], resolve).default
                            },
                        },
                        {
                            path: 'documents',
                            component: function (resolve) {
                                require(['../components/activities/settings/documentsList.vue'], resolve).default
                            },
                        },
                        {
                            path: 'tasks',
                            component: function (resolve) {
                                require(['../components/activities/settings/tasks.vue'], resolve).default
                            },
                        },
                    ]
                },
            ]
        },
        {
            path: '/events/:id/manage',
            component: function (resolve) {
                require(['../components/events/settings/main.vue'], resolve).default
            },
            meta: {auth: true},
            children: [
                {
                    path: '',
                    component: function (resolve) {
                        require(['../components/events/settings/settings.vue'], resolve).default
                    },
                },
                {
                    path: 'papers',
                    component: function (resolve) {
                        require(['../components/events/settings/List.vue'], resolve).default
                    },
                },
                {
                    path: 'collection',
                    component: function (resolve) {
                        require(['../components/events/settings/collection.vue'], resolve).default
                    },
                },
                {
                    path: 'timetable',
                    component: function (resolve) {
                        require(['../components/events/settings/timetable/timetable.vue'], resolve).default
                    },
                },
                {
                    path: 'mailing',
                    component: function (resolve) {
                        require(['../components/events/settings/mailing.vue'], resolve).default
                    },
                },
                {
                    path: 'review',
                    component: function (resolve) {
                        require(['../components/events/settings/review.vue'], resolve).default
                    },
                },
                {
                    path: 'rules',
                    component: function (resolve) {
                        require(['../components/events/settings/rules.vue'], resolve).default
                    },
                },
                {
                    path: 'payment',
                    component: function (resolve) {
                        require(['../components/events/settings/payment.vue'], resolve).default
                    },
                },
                {
                    path: 'publications',
                    component: function (resolve) {
                        require(['../components/events/settings/publications.vue'], resolve).default
                    },
                },
                {
                    path: 'statistics',
                    component: function (resolve) {
                        require(['../components/events/settings/statistics.vue'], resolve).default
                    },
                }
            ]
        },
        {
            path: '/events/:id/:action',
            name: 'EventActions',
            component: function (resolve) {
                require(['../components/events/show.vue'], resolve).default
            }
        },
        {
            path: '/events/:id/page/:page_id',
            name: 'Event',
            component: function (resolve) {
                require(['../components/events/show.vue'], resolve).default
            }
        },
        {
            path: '/events/list',
            name: 'EventsList',
            component: function (resolve) {
                require(['../components/events/settings/List.vue'], resolve).default
            }
        },
        {
            path: '/documents',
            name: 'Documents',
            component: function (resolve) {
                require(['../components/activities/documents/Documents.vue'], resolve).default
            }
        },

        {
            path: '/applications',
            name: 'Applications',
            component: function (resolve) {
                require(['../components/applications/Applications.vue'], resolve).default
            },
            meta: {auth: true}
        },
        {
            path: '/applications/edit/:id',
            name: 'ApplicationsEdit',
            component: function (resolve) {
                require(['../components/applications/paper_edit.vue'], resolve).default
            },
            meta: {auth: true}
        },
        {
            path: '/chat',
            name: 'Chat',
            component: function (resolve) {
                require(['../components/chat/Chat.vue'], resolve).default
            },
            meta: {auth: true}
        },
        {
            path: '/friends',
            name: 'Friends',
            component: function (resolve) {
                require(['../components/friends/Friends.vue'], resolve).default
            },
            meta: {auth: true}
        },
        {
            path: '/review',
            name: 'Review',
            component: function (resolve) {
                require(['../components/review/Review.vue'], resolve).default
            },
            meta: {auth: true}
        },
        {
            path: '/review/form/:id',
            name: 'ReviewForm',
            component: function (resolve) {
                require(['../components/review/ReviewForm.vue'], resolve).default
            },
            meta: {auth: true}
        },
        {
            path: '/review/dialog/:id',
            name: 'ReviewDialog',
            component: function (resolve) {
                require(['../components/review/ReviewDialog.vue'], resolve).default
            },
            meta: {auth: true}
        },
        {
            path: '/login',
            name: 'login',
            component: require('../components/pages/Login.vue').default,
            meta: {auth: false}
        },
        {
            path: '/login/:type',
            name: 'oauth2-type',
            component: require('../components/pages/Oauth2.vue').default,
            meta: {auth: false}
        },
        {
            path: '/register',
            name: 'register',
            component: require('../components/pages/Register.vue').default,
            meta: {auth: false}
        },
        {
            path: '/oauth1',
            name: 'oauth1',
            component: require('../components/pages/Oauth1.vue').default,
            meta: {auth: false}
        },
        {
            path: '/oauth2',
            name: 'oauth2',
            component: require('../components/pages/Oauth2.vue').default,
            meta: {auth: false}
        },
        {
            path: '/account',
            name: 'account',
            component: require('../components/pages/Account.vue').default,
            meta: {auth: true}
        },
        {
            path: '/async',
            name: 'async',
            component: function (resolve) {
                require(['../components/pages/Async.vue'], resolve).default
            }
        },
        {
            path: '/404',
            name: 'error-404',
            component: require('../components/pages/404.vue').default
        },
        {
            path: '/403',
            name: 'error-403',
            component: require('../components/pages/403.vue').default
        },
        {
            path: '/502',
            name: 'error-502',
            component: require('../components/pages/502.vue').default
        },
        {
            path: '*',
            redirect: '/404'
        },
        {
            path: '*@:id',
            name: 'NotFound',
            component: function (resolve) {
                require(['../components/users/User.vue'], resolve).default
            }
        }]
})
